import CityPageTemplate from './CityPageTemplate';

const cityData = {
  cityName: "Saint Paul",
  metaDescription: "Professional plumbing services in Saint Paul, MN. Bruce Nelson Plumbing & Heating offers residential and commercial plumbing, boiler service, water heater repair. Call 651-738-9354.",
  heroTitle: "Plumber in Saint Paul, MN",
  heroSubtitle: "Trusted plumbing and heating services for Saint Paul homes and businesses since 1976.",
  introduction: "Looking for a reliable plumber in Saint Paul? Bruce Nelson Plumbing & Heating has been serving the capital city of Minnesota for nearly 50 years. From the historic Summit Avenue homes to modern downtown businesses, we understand the unique plumbing challenges that Saint Paul properties face, including aging infrastructure and harsh Minnesota winters.",
  services: [
    {
      title: "Residential Plumbing",
      description: "Complete plumbing services for Saint Paul homes, from repairs to full remodels.",
      link: "/services/residential"
    },
    {
      title: "Commercial Plumbing",
      description: "Professional plumbing solutions for Saint Paul businesses and commercial properties.",
      link: "/services/commercial"
    },
    {
      title: "Boiler Service",
      description: "Expert boiler installation, repair, and maintenance to keep your Saint Paul home warm.",
      link: "/services/boilers"
    },
    {
      title: "Water Heater Repair",
      description: "Fast water heater repair and installation services throughout Saint Paul.",
      link: "/services/water-heaters"
    },
    {
      title: "Bathroom Remodeling",
      description: "Transform your Saint Paul bathroom with our expert remodeling services.",
      link: "/services/remodeling"
    },
    {
      title: "Drain Cleaning",
      description: "Professional drain cleaning to keep your Saint Paul plumbing flowing smoothly.",
      link: "/services"
    }
  ],
  whyChooseUs: [
    "Serving Saint Paul and the Twin Cities since 1976",
    "Licensed, bonded, and insured Minnesota plumbers",
    "Experienced with historic Saint Paul homes and older plumbing systems",
    "Upfront, transparent pricing with no hidden fees",
    "Fast response times throughout Saint Paul neighborhoods",
    "4.8-star rating with hundreds of satisfied customers"
  ],
  serviceAreas: [
    { name: "Minneapolis", link: "/plumber-minneapolis" },
    { name: "Oakdale", link: "/plumber-oakdale" },
    { name: "Woodbury", link: "/plumber-woodbury" },
    { name: "Maplewood", link: "/plumber-maplewood" },
    { name: "Eagan", link: "/plumber-eagan" },
    { name: "Rosemount", link: "/plumber-rosemount" }
  ],
  testimonial: {
    text: "BNPH has been our go-to plumber for years. They're always professional, on time, and do excellent work. Highly recommend them to anyone in Saint Paul!",
    author: "David W."
  }
};

const SaintPaulPage = () => <CityPageTemplate cityData={cityData} />;

export default SaintPaulPage;
